
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"lock-shield"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.875 3.27v6.344a9.922 9.922 0 006.36 9.261l.867.333a2.5 2.5 0 001.796 0l.867-.333a9.923 9.923 0 006.36-9.26V3.268a1.24 1.24 0 00-.723-1.135A18.083 18.083 0 0010 .625a18.083 18.083 0 00-7.402 1.51 1.24 1.24 0 00-.723 1.134z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.5 8.125h-5c-.69 0-1.25.56-1.25 1.25v3.75c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-3.75c0-.69-.56-1.25-1.25-1.25zM10 4.375a2.5 2.5 0 00-2.5 2.5v1.25h5v-1.25a2.5 2.5 0 00-2.5-2.5z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10 11.587a.312.312 0 110-.625m0 .625a.312.312 0 100-.625","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round"}})])
          )
        }
      }
    